import React from 'react';

/**
 * A row of mutually exclusive choices.
 *
 * options: [{ value, label, icon?: LucideIcon, count?: number, countClass?: string, title?: string }]
 * `role="tablist"` when the segments switch a view below them; pass `label` for screen readers.
 */
function SegmentedControl({ options, value, onChange, label, className = '', size = 'md', fullWidth = false }) {
  return (
    <div
      role="tablist"
      aria-label={label}
      className={`pp-segmented ${fullWidth ? 'flex w-full' : ''} ${className}`}
    >
      {options.map((option) => {
        const selected = option.value === value;
        const Icon = option.icon;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            title={option.title}
            onClick={() => onChange(option.value)}
            className={`pp-segment ${size === 'sm' ? '!h-6 !gap-1 !px-1.5 !text-xs' : ''}`}
          >
            {Icon && <Icon size={size === 'sm' ? 12 : 14} className="flex-shrink-0" />}
            {option.label}
            {option.count !== undefined && option.count !== null && (
              <span className={`text-2xs tabular-nums ${selected ? option.countClass || 'text-pp-muted' : 'text-pp-faint'}`}>
                {option.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
